module.exports = __webpack_public_path__ + "img/account-white_new.8f791a27.svg";